module.exports = __webpack_public_path__ + "static/media/web-4.7d54c8f5.png";